<template>
  <v-card>
    <v-card-title>
      <h2>{{ hidden ? 'Show ' : 'Hide ' }} Organization?</h2>
    </v-card-title>

    <v-card-text>
      <p>
        Are you sure you wish to change the visibility status of this organization?
      </p>
      <p v-if="!hidden">
        This action will hide the organization. It will not be displayed for any future questionnaire results. Any lender accounts with access to this organization will not be able to view or manage it. If any of its products are part of an active deal, those will still be visible. If any of its products are registered in an ad slot, those will still be displayed.
      </p>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="default-btn text" @click="$emit('cancel')">Cancel</v-btn>
      <v-btn color="default-btn green" @click="$emit('confirm')">
        {{ hidden ? 'Show ' : 'Hide ' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ConfirmToggleHidden',
  props: {
    hidden: Boolean,
  },
}
</script>

<style lang="scss" scoped></style>
